import React,{useState, useEffect} from 'react'
import TitleItemShop from '../pages/TitleItemShop'
import { Link } from 'react-router-dom'
import ImageAspectRatio from './utils/ImageAspectRatio';
import MySlider from '../MySlider';


export default function ShopItem(params) {
    const [variazione,setVariazione] = useState(undefined)
    
    function getBestVariazione(listOfVariazioni){
        let price = null;

        listOfVariazioni.forEach(vari => {
            let tmp_price = 0
            if(vari.sale_price !== null && vari.validity_for !== null && new Date(vari.validity_for).getTime() > new Date().getTime()){
                tmp_price = vari.price - (vari.price * (vari.sale_price / 100));
            }else if(vari.sale_price !== null && vari.validity_for === null){
                tmp_price = vari.price - (vari.price * (vari.sale_price / 100));
            }else{
                tmp_price = vari.price;
            }
            if(price == null){
                price = tmp_price
                setVariazione(vari)
            }else if(tmp_price < price){
                price = tmp_price
                setVariazione(vari)
            }
        })
    }

    useEffect(() => {
        getBestVariazione(params.item.variation_set)
    }, [params.item])

    return(
        variazione ?
        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <Link style={{textDecoration:"none"}} to= {{ 
                    pathname: "/shop/"+params["item"]["gurl"]+"/"+params["item"]["id"],
                    product: params["item"]
                }}>
                    <div className="card">
                        <div>
                            <MySlider aspectratio={"4:3"} immagini={variazione && variazione.variationimage_set[0]  ? [variazione.variationimage_set[0]]:[]} ></MySlider>
                        </div>
                        <div className="card-detail">
                        <div className="shop-item-variazione">
                            {params.item.variation_set.length} varianti
                        </div>
                        <div className="shop-item-title">
                            <div>{params.item.title}</div>
                        </div>
                        {variazione ?
                            <div className="shop-item-prezzo" style={{color:"black",paddingRight:"15px"}}>
                                {variazione.sale_price !== null && variazione.validity_for !== null && new Date(variazione.validity_for).getTime() > new Date().getTime() ? 
                                <div>
                                    <span className="shop-item-sconto">{variazione.price}€</span> - <b>{variazione.price - (variazione.price * (variazione.sale_price / 100))}€</b>
                                    {variazione.validity_for !== null ?
                                        <div style={{fontSize:"14px",position:"absolute",top:"5px",right:"5px"}}>
                                            <i style={{color:"black"}} className="far fa-clock"></i>
                                        </div>
                                    :null}
                                </div>
                                :
                                variazione.sale_price !== null && variazione.validity_for === null ? 
                                    <>
                                        <span style={{textDecoration: "line-through",fontSize:"15px"}}>{variazione.price}€</span> - <b>{variazione.price - (variazione.price * (variazione.sale_price / 100))}€</b>
                                    </>
                                    : <b>{variazione.price} €</b>
                                }
                            </div>
                        :null}
                        </div>
                    </div>
            </Link>
        </div>
        : null
    )
}